import { useState, useEffect } from 'react'
import { useLocal } from 'hooks/useLocal'

export const useListaLocais = ({ idExameSolicitado, idExameRealizado, setFormLocaisErro }) => {
  const localHook = useLocal()
  const [carregando, setCarregando] = useState(false)
  const [locais, setLocais] = useState([])

  const fetchLocais = async () => {
    const data = await localHook.getLocaisDeExame(idExameSolicitado, setCarregando)
    setLocais(data || [])
  }

  useEffect(() => {
    fetchLocais()
  }, [idExameSolicitado, idExameRealizado])

  const getAnaliseLocalDeExame = (local) => {
    let anaLoc = null
    if (local.anaLocs) {
      local.anaLocs.forEach((analiseLocal) => {
        if (analiseLocal.id_exame_local == idExameRealizado) {
          anaLoc = analiseLocal
        }
      })
    }
    return anaLoc
  }

  useEffect(() => {
    let count = 0
    if (locais && locais.length) {
      locais.forEach((local) => {
        if (local.anaLocs && local.anaLocs.length) {
          local.anaLocs.forEach((analiseLocal) => {
            if (analiseLocal.id_exame_local == idExameRealizado) {
              count += 1
            }
          })
        }
      })
    }
    
    if (locais.length > 0 && count === locais.length) {
      setFormLocaisErro(false)
    } else {
      setFormLocaisErro(true)
    }
  }, [locais, idExameRealizado, setFormLocaisErro])

  return {
    carregando,
    locais,
    fetchLocais,
    getAnaliseLocalDeExame,
  }
}
